'use client';

import { useMediaQuery } from '@zg-rentals/react-hooks';
import { MIN_LG } from '@/src/lib/breakpoints';

export function useIsDesktop(): boolean {
  return useMediaQuery(MIN_LG);
}

/**
 * One-shot read of the same breakpoint, for callers that need the settled value
 * outside of render (`useIsDesktop` reports mobile until hydration settles).
 */
export function matchesDesktopViewport(): boolean {
  return typeof window !== 'undefined' && window.matchMedia(MIN_LG).matches;
}
